import {
  FETCH_ADDON_BOOKING_AVAILABILITY,
  FETCH_OFFER_PACKAGE_ADDONS,
} from 'actions/apiActionConstants'
import { createAppReducer, apiReducerSwitch } from 'lib/redux/reducerUtils'
import {
  API_CALL_REQUEST,
  API_CALL_FAILURE,
  API_CALL_SUCCESS,
} from 'actions/actionConstants'

export const initialAddonState: App.AddonState = {
  fetchingAvailability: false,
  fetchingAvailabilityError: '',
  addonAvailability: {},
  addonsByPackage: {},
  addonsByPackageLoading: {},
}

const apiCalls = apiReducerSwitch<App.AddonState>({
  [FETCH_ADDON_BOOKING_AVAILABILITY]: {
    request: () => ({
      fetchingAvailability: true,
      fetchingAvailabilityError: undefined,
    }),
    success: (state, action) => ({
      fetchingAvailability: false,
      fetchingAvailabilityError: undefined,
      addonAvailability: {
        ...state.addonAvailability,
        [action.addonId]: action.data,
      },
    }),
    failure: (state, action) => ({
      fetchingAvailability: false,
      fetchingAvailabilityError: action.error,
    }),
  },
  [FETCH_OFFER_PACKAGE_ADDONS]: {
    request: (state, action) => ({
      addonsByPackageLoading: {
        ...state.addonsByPackageLoading,
        [action.packageId]: true,
      },
    }),
    success: (state, action) => ({
      addonsByPackage: {
        ...state.addonsByPackage,
        [action.packageId]: action.data,
      },
      addonsByPackageLoading: {
        ...state.addonsByPackageLoading,
        [action.packageId]: false,
      },
    }),
    failure: (state, action) => ({
      addonsByPackageLoading: {
        ...state.addonsByPackageLoading,
        [action.packageId]: false,
      },
    }),
  },
})

export default createAppReducer<App.AddonState>(initialAddonState, {
  [API_CALL_REQUEST]: (state, action) => apiCalls(state, action),
  [API_CALL_FAILURE]: (state, action) => apiCalls(state, action),
  [API_CALL_SUCCESS]: (state, action) => apiCalls(state, action),
})
